import React from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import confirmAlert
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import CSS

const justConfirm = () => {
    const confirm = () => {
        return new Promise((resolve) => {
            confirmAlert({
                customUI: ({ onClose }) => (
                    <div className="max-w-96 p-4 px-8 rounded-2xl flex flex-col gap-4 bg-slate-50 shadow-sm costum-ui">
                        <div className="bg-yellow-400 w-32 font-bold text-xl flex text-white justify-center items-center px-4 py-2 rounded-lg ">
                            Announce
                        </div>
                        <p>
                            "Kamu berada diluar jangakuan Dhoho TV!, Apakah kamu ada tugas diluar?
                            Jika iya kamu tetap bisa absen akan tetapi akan diterima melalui
                            keputusan admin",
                        </p>
                        <div className="flex gap-2 justify-end">
                            <div
                                className="flex cursor-pointer justify-center text-xs items-center px-4 py-2 rounded-lg font-semibold bg-slate-300 text-slate-500"
                                onClick={() => {
                                    onClose();
                                    resolve(false); // Mengembalikan false jika Cancel ditekan
                                }}
                            >
                                Cancel
                            </div>
                            <div
                                className="flex cursor-pointer text-xs text-white justify-center items-center px-4 py-2 rounded-lg font-semibold bg-green-700"
                                onClick={() => {
                                    onClose();
                                    resolve(true); // Mengembalikan true jika OK ditekan
                                }}
                            >
                                OK
                            </div>
                        </div>
                    </div>
                ),
                closeOnEscape: true,
                closeOnClickOutside: true,
                overlayClassName: "overlay-custom-class-name",
            });
        });
    };

    return { confirm };
};

export default justConfirm;
